module.exports = new __parcel__URL__("profileIcon.fdb167aa.svg").toString();